import React, { useEffect, useState } from "react";
import { API_URL, createAxiosInstance } from "../../../../api";
import { Link, useLocation } from "react-router-dom";
import SweetAlert from "sweetalert2";
import { useSelector } from "react-redux";
import "./ChangePlan.css";
import config from "config";
import successIcon from "../../../../assets/success-icon.svg";

import {
  Badge,
  Box,
  Button,
  Link as MuiLink,
  Menu,
  MenuItem,
} from "@mui/material";

const ChangePlan = () => {
  const { email } = useSelector((state) => state.profile.user);
  const [currentPlan, setCurrentPlan] = useState(null);
  const [loading, setLoading] = useState(false);
  const [status, setStatus] = useState(""); // New state for subscription status
  const location = useLocation();
  const userId = useSelector((state) => state.profile.user.user);
  console.log(userId);

  useEffect(() => {
    const fetchBillingStatus = async () => {
      setLoading(true); // Show loader while fetching data
      try {
        const axiosInstance = createAxiosInstance();
        const response = await axiosInstance.get(
          `${API_URL}/api/billings/status/${userId}`
        );

        const { membership, price, status } = response.data;

        // Set current plan based on the price (e.g., 15 for Monthly, 150 for Yearly)
        setCurrentPlan(
          price === 2 ? "Monthly Subscription" : "Yearly Subscription"
        );

        // Set subscription status
        setStatus(status);
      } catch (error) {
        console.error("Error fetching billing data:", error);
        SweetAlert.fire({
          title: "Error",
          text: "Failed to load billing status.",
          icon: "error",
          confirmButtonText: "Ok",
        });
      } finally {
        setLoading(false); // Hide loader once data is fetched or error occurs
      }
    };

    if (userId) {
      fetchBillingStatus();
    }
  }, [userId]);

  const handleChangePlan = async (planName) => {
    const result = await SweetAlert.fire({
      title: "Change Plan",
      text: `Are you sure you want to switch to the ${planName}?`,
      icon: "question",
      showCancelButton: true,
      confirmButtonText: "Yes, change plan",
      cancelButtonText: "Cancel",
      confirmButtonColor: "#712d94",
    });

    if (result.isConfirmed) {
      try {
        setLoading(true);
        const response = await createAxiosInstance().post(
          `${API_URL}/api/billings/changeplan/${userId}`,
          { planName }
        );

        SweetAlert.fire({
          imageUrl: successIcon,
          title: "Success",
          text: response.data.message,
          confirmButtonText: "Great",
          confirmButtonColor: "#712d94",
        });

        setCurrentPlan(planName); // Update the UI to reflect the new plan
      } catch (error) {
        console.error("Error changing plan:", error);
        SweetAlert.fire({
          title: "Error",
          text: error.response?.data?.message || "Failed to change plan.",
          icon: "error",
          confirmButtonText: "Ok",
        });
      } finally {
        setLoading(false);
      }
    }
  };

  const handleReactivate = async (planName, userId) => {
    try {
      const response = await createAxiosInstance().post(
        `${API_URL}/api/billings/reactivate/${userId}`,
        {
          planName,
        }
      );

      if (response.data.success) {
        SweetAlert.fire({
          title: "Success",
          text: response.data.message,
          icon: "success",
          confirmButtonText: "OK",
        });
      } else {
        throw new Error(
          response.data.message || "Failed to reactivate subscription."
        );
      }
    } catch (error) {
      console.error("Error reactivating subscription:", error);
      SweetAlert.fire({
        title: "Error",
        text:
          error.response?.data?.message || "Could not reactivate subscription.",
        icon: "error",
        confirmButtonText: "OK",
      });
    }
  };

  return (
    <div className="billing-container">
      <div className="billing-menu">
        <div className="returnToDash">
          {" "}
          <Link to="/dashboard">
            <svg
              id="Layer_1"
              data-name="Layer 1"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 122.88 108.06"
            >
              <title>back-arrow</title>
              <path d="M63.94,24.28a14.28,14.28,0,0,0-20.36-20L4.1,44.42a14.27,14.27,0,0,0,0,20l38.69,39.35a14.27,14.27,0,0,0,20.35-20L48.06,68.41l60.66-.29a14.27,14.27,0,1,0-.23-28.54l-59.85.28,15.3-15.58Z" />
            </svg>
            Back To Dashboard
          </Link>
        </div>
        <Link
          className={`tab${
            location.pathname === "/billing"
              ? " active " + config["class-name"]
              : ""
          }`}
          to="/billing"
        >
          My Plan
        </Link>
        <Link
          className={`tab${
            location.pathname === "/billing/history"
              ? " active " + config["class-name"]
              : ""
          }`}
          to="/billing/history"
        >
          History
        </Link>
        <Link
          className={`tab${
            location.pathname === "/billing/saved-cards"
              ? " active " + config["class-name"]
              : ""
          }`}
          to="/billing/saved-cards"
        >
          Saved Cards
        </Link>
        <Link
          className={`tab${
            location.pathname === "/billing/change-plan"
              ? " active " + config["class-name"]
              : ""
          }`}
          to="/billing/change-plan"
        >
          Change Plan
        </Link>
      </div>

      <div className="billing-content">
        <div className="change-plan-container">
          <h2 style={{ textAlign: "center" }}>Change Plan</h2>

          {loading ? (
            <p style={{ textAlign: "center" }}>Loading billing status...</p>
          ) : (
            <table>
              <thead>
                <tr>
                  <th>Plan Name</th>
                  <th>Price</th>
                  <th>Actions</th>
                </tr>
              </thead>
              <tbody>
                {[
                  { name: "Monthly Subscription", price: "£2.00/month" },
                  { name: "Yearly Subscription", price: "£24.99/year" },
                ].map((plan) => (
                  <tr key={plan.name}>
                    <td>{plan.name}</td>
                    <td>{plan.price}</td>
                    <td>
                      {currentPlan === plan.name ? (
                        // Handle Current Plan based on status
                        status === "active" ? (
                          <span>Current Plan</span>
                        ) : status === "past_due" ? (
                          <button
                            onClick={() => handleReactivate(plan.name, email)}
                          >
                            Reactivate
                          </button>
                        ) : (
                          <button
                            onClick={() => handleReactivate(plan.name, email)}
                          >
                            Choose Plan
                          </button>
                        )
                      ) : (
                        // Handle Other Plan based on status
                        <Button
                          variant="contained"
                          color="primary"
                          onClick={() => handleChangePlan(plan.name)}
                        >
                          {status === "past_due"
                            ? "Change Plan"
                            : "Choose Plan"}
                        </Button>
                      )}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}
        </div>
      </div>
    </div>
  );
};

export default ChangePlan;
